import { ZaiChatCenterStage } from '@winnin/zai-chat'
import '@winnin/zai-chat/styles.css'

import './zai-chat-desktop-page.styles.scss'

export function ZaiChatDesktopPage() {
  return (
    <div className="ZaiChatDesktopPage">
      <ZaiChatCenterStage />
    </div>
  )
}
